<template>
    <div class="w-full relative overflow-hidden" :class="backgroundClasses">
        <div :style="progressStyle" class="h-full" :class="classes"/>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { animate } from 'popmotion'

const props = defineProps({
  progress: {
    type: Number,
    required: true
  },
  color: {
    type: String,
    default: 'white'
  },
  rounded: {
    type: Boolean,
    default: true
  },
  backgroundColor: {
    type: String,
    default: 'black/20'
  },
  unanimatedBackward: {
    type: Boolean,
    default: false
  },
  unanimated: {
    type: Boolean,
    default: false
  }
})

const initialProgress = ref(0)
let animationInstance = null

const progressStyle = computed(() => {
  return {
    width: initialProgress.value ? `${parseFloat(initialProgress.value).toFixed(4)}%` : '0'
  }
})

const classes = computed(() => {
  return {
    [`bg-${props.color}`]: true,
    'rounded-full': props.rounded,
  }
})

const backgroundClasses = computed(() => {
  return {
    [`bg-${props.backgroundColor}`]: true,
    'rounded-full': props.rounded,
  }
})

const updateProgress = (from, to) => {
  if (from === to) return
  if (animationInstance) {
    animationInstance.stop()
    animationInstance = null
  }
  animationInstance = animate({
    from,
    to,
    ease: (t) => t,
    onUpdate: (v) => initialProgress.value = v,
    onComplete: () => { animationInstance = null }
  })
}

watch(() => props.progress, (newVal, oldValue) => {
  if (props.unanimated || (props.unanimatedBackward && newVal < oldValue)) {
    if (animationInstance) {
      animationInstance.stop()
      animationInstance = null
    }
    initialProgress.value = newVal
    return
  }

  if (newVal !== initialProgress.value) {
    updateProgress(initialProgress.value, newVal)
  }
})

onMounted(() => {
  if (props.progress && !isNaN(initialProgress.value)) {
    if (animationInstance) {
      animationInstance.stop()
      animationInstance = null
    }
    initialProgress.value = 0
    updateProgress(0, props.progress)
  }
})

onBeforeUnmount(() => {
  if (animationInstance) {
    animationInstance.stop()
    animationInstance = null
  }
})
</script>
